export function parseKeywordInput(input: string) {
  return input
    .split(",")
    .map((keyword) => keyword.trim())
    .filter(Boolean);
}

export function mergeKeywords(existing: string[], additions: string[]) {
  const result = [...existing];
  const seen = new Set(existing.map((keyword) => keyword.toLowerCase()));

  additions.forEach((keyword) => {
    const normalized = keyword.toLowerCase();
    if (seen.has(normalized)) return;

    seen.add(normalized);
    result.push(keyword);
  });

  return result;
}
